import React, { useState, useEffect, Fragment, useRef } from 'react';
import './Settings.scss';
import PointdeRetrait from '../config/PointdeRetrait';
import ReactLoading from 'react-loading';
import { fireauth } from '../config/firebase.config';
import moment from 'moment'
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import TextField from '@material-ui/core/TextField';
import MomentUtils from '@date-io/moment';

import green from "@material-ui/core/colors/green";
import InputAdornment from '@material-ui/core/InputAdornment';


import DataTable from 'react-data-table-component';
import Collapsible from 'react-collapsible';

const defaultMaterialTheme = createTheme({
    palette: {
        primary: green,
    },
});

const SCREENS = [
    {
        id: "ouv1",
        menuname: "Ouverture des points de retraits",
        render: (pdr) => <Heure pdr={pdr} />
    },
    { id: "fdsmenu", menuname: "Frais de services", render: (pdr) => <FraisdeServe key={`fds_${new Date()}`} pdr={pdr}></FraisdeServe> },
    { id: "dispoprid", menuname: "Disponibilité des produits", render: (pdr) => <DispoProduit pdr={pdr}></DispoProduit> },
    { id: "pricprd", menuname: "Tarification des produits", render: (pdr) => <TarifProduit pdr={pdr}></TarifProduit> },
]

export default class Settings extends React.Component {
    unsubscribe = null;


    constructor(props) {
        super(props);
        this.state = {
            PDRList: [],
            pdr: undefined,
            screen: SCREENS[0],
            loading: true,
        }
    }

    componentDidMount() {
        this.unsubscribe = PointdeRetrait.stream((data) => {
            this.setState({
                PDRList: data,
                pdr: this.state.pdr ?? data[0],
                loading: false,
            })
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        if (this.state.loading)
            return (<div className="root"><ReactLoading type="spin" color="#0e2819" className="ReactLoading" height={150} width={150} /></div>)
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <div className="root">
                    <div className="topbanner">
                        <PdrMenu listeDesPointsDeRetrait={this.state.PDRList} selectedPointdeRetrait={this.state.pdr} onClick={(_pdr) => this.setState({ pdr: _pdr })}></PdrMenu>
                        <PdrSousMenu currentScreen={this.state.screen} onClick={(sm) => this.setState({ screen: sm })}></PdrSousMenu>
                        <div className="elementor-button-wrapper red">
                            <a onClick={(e) => {
                                fireauth.signOut()
                            }} className="elementor-button-link elementor-button elementor-size-lg" role="button">
                                <span className="elementor-button-content-wrapper">
                                    <span className="elementor-button-text">Se deconnecter</span>
                                </span>
                            </a>
                        </div>
                    </div>
                    <PdreElement pdr={this.state.pdr} currentScreen={this.state.screen}></PdreElement>
                </div>
            </MuiPickersUtilsProvider>)
    }








}

class PdrMenu extends React.Component {
    render() {
        let { listeDesPointsDeRetrait, selectedPointdeRetrait, onClick } = this.props;
        return (
            <div className="PdrMenu">
                {listeDesPointsDeRetrait.map(pdr =>
                    <div
                        key={`it_${pdr.id}_m`}
                        className={"item " + (pdr.id === selectedPointdeRetrait.id ? "selected" : "")}
                        onClick={() => onClick(pdr)}>
                        <div className={"item_inner " + (pdr.opened ? "open" : "closed")} >
                            {pdr.name}
                        </div>
                    </div>
                )}
            </div>)
    }
}

class PdrSousMenu extends React.Component {
    render() {
        let { currentScreen, onClick } = this.props;

        return (<div className="PdrSousMenu">
            {SCREENS.map(scr =>
                <div key={`it_${scr.id}_m`} className={"item " + (scr.id === currentScreen.id ? "selected" : "")} onClick={() => onClick(scr)}>{scr.menuname}</div>
            )}
        </div>)
    }
}

class PdreElement extends React.Component {
    render() {
        let { pdr, currentScreen } = this.props;
        return (
            <div className="pdrcontainer">
                <div className="pdrelement">
                    <div className={"Header " + (pdr.opened ? "open" : "closed")}>{pdr.name}</div>
                    <div className={"contents " + (pdr.opened ? "open" : "closed")}>
                        {currentScreen.render(pdr)}
                        <div className="openme" key={`opndm${pdr.id}`}>
                            <label className="switch">
                                <input type="checkbox" onClick={() => {
                                    pdr.opened = !pdr.opened
                                    PointdeRetrait.update(pdr)
                                }
                                } defaultChecked={pdr.opened}></input>
                                <span className={"slider round " + (pdr.opened ? "open" : "closed")}>{pdr.opened ? "Ouvert" : "Fermé"}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const InlineTimePickerDemo = ({ label, value, Onchange }) => {
    const [selectedDate, handleDateChange] = useState(value);

    return (
        <Fragment>
            <ThemeProvider theme={defaultMaterialTheme}>
                <TimePicker
                    variant="inline"
                    label={label}
                    value={selectedDate}
                    ampm={false}
                    onChange={e => {
                        handleDateChange(e)
                        Onchange(e)
                    }}
                    invalidDateMessage="Heure non valide"
                    clearLabel="Effacer"
                    cancelLabel="Annuler"
                    okLabel="Ok"
                    variant='dialog'
                />

            </ThemeProvider>
        </Fragment>
    );
}

const Heure = ({ pdr }) => {
    return (<div>
        <div className="heurelimit">
            <div className="hours">
                <div className="days">
                    <div className="dayname">Lundi</div>
                    <div className="day">
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="1"></HeureDay></div>
                    <div className="dayname">Mardi</div>
                    <div className="day" >
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="2"></HeureDay></div >
                    <div className="dayname">Merdredi</div>
                    <div className="day" >
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="3"></HeureDay></div >
                    <div className="dayname">Jeudi</div>
                    <div className="day" >
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="4"></HeureDay></div >
                    <div className="dayname">Vendredi</div>
                    <div className="day" >
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="5"></HeureDay></div >
                    <div className="dayname">Samedi</div>
                    <div className="day" >
                        <HeureDay key={`hrlm${pdr.id}_${new Date()}`} pdr={pdr} dayofweek="6"></HeureDay></div >
                </div >

            </div>
        </div>
    </div>
    )
}
const HeureDay = ({ pdr, dayofweek }) => {

    const fn_dayOfWeek = (m) => moment.weekdays()[m]
    let day = pdr.hours[fn_dayOfWeek(dayofweek)]


    let OpentTime = day.ouverture instanceof Date ? day.ouverture : day.ouverture.toDate()
    let CloseTime = day.fermeture instanceof Date ? day.fermeture : day.fermeture.toDate()


    return (<div>
        <div className="edit">
            <span>De</span>
            <InlineTimePickerDemo label="Ouverture" value={OpentTime}
                Onchange={(e) => {
                    day.ouverture = e.toDate()
                    PointdeRetrait.update(pdr)

                }}
            />
            <span> à </span>
            <InlineTimePickerDemo label="Fermeture" value={CloseTime}
                Onchange={(e) => {
                    day.fermeture = e.toDate()
                    PointdeRetrait.update(pdr)

                }}
            />
        </div>
    </div>
    )
}
const TarifProduit = ({ pdr }) => {

    var pdrGarniture = pdr.ConfigMenu.Garnitures[0]
    var pdrSimplePetit = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b1").taille.find(tx => tx.name === "petit")
    var pdrSimplegrand = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b1").taille.find(tx => tx.name === "grand")
    var pdrDuoPetit = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b2").taille.find(tx => tx.name === "petit")
    var pdrDuoGrand = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b2").taille.find(tx => tx.name === "grand")
    var pdrTrioPersoGrand = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b3").taille.find(tx => tx.name === "grand")
    var pdrTrioChefPetit = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b4").taille.find(tx => tx.name === "petit")
    var pdrTrioChefGrand = pdr.ConfigMenu.Boissons.find(bx => bx.ref === "react_internal_ref_b4").taille.find(tx => tx.name === "grand")



    const BoissonSimple = () => {

        const [SimplePetit, setSimplepetit] = useState(pdrSimplePetit.prix ?? 0)
        const [SimpleGrand, setSimplegrand] = useState(pdrSimplegrand.prix ?? 0)

        const mounted = useRef(false);
        useEffect(() => {
            mounted.current = true;
            return () => {
                mounted.current = false;
            };
        }, []);

        return (
            <><TextFieldUpdateOnChange label="Petit"
                InputProps={{
                    endAdornment: <InputAdornment position="end">€</InputAdornment>
                }}
                value={SimplePetit}
                onChange={(e) => {
                    pdrSimplePetit.prix = parseFloat(e)
                    if (mounted.current)
                        setSimplepetit(pdrSimplePetit.prix)
                    PointdeRetrait.update(pdr)
                }} />
                <TextFieldUpdateOnChange label="Grand"
                    InputProps={{
                        endAdornment: <InputAdornment position="end">€</InputAdornment>
                    }}
                    value={SimpleGrand}
                    onChange={(e) => {
                        pdrSimplegrand.prix = parseFloat(e)
                        if (mounted.current)
                            setSimplegrand(pdrSimplegrand.prix)
                        PointdeRetrait.update(pdr)
                    }} /></>)
    }
    const BoissonDuo = () => {
        const [DuoPetit, setDuopetit] = useState(pdrDuoPetit.prix ?? 0)
        const [DuoGrand, setDuogrand] = useState(pdrDuoGrand.prix ?? 0)
        const mounted = useRef(false);
        useEffect(() => {
            mounted.current = true;
            return () => {
                mounted.current = false;
            };
        }, []);
        return (<><TextFieldUpdateOnChange label="Petit"
            InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>
            }}
            value={DuoPetit}
            onChange={(e) => {
                pdrDuoPetit.prix = parseFloat(e)
                if (mounted.current)
                    setDuopetit(pdrDuoPetit.prix)
                PointdeRetrait.update(pdr)
            }}
        />
            <TextFieldUpdateOnChange label="Grand"
                InputProps={{
                    endAdornment: <InputAdornment position="end">€</InputAdornment>
                }}
                value={DuoGrand}
                onChange={(e) => {
                    pdrDuoGrand.prix = parseFloat(e)
                    if (mounted.current)
                        setDuogrand(pdrDuoGrand.prix)
                    PointdeRetrait.update(pdr)
                }}
            /></>)
    }
    const BoissonTrioPerso = () => {
        const [TrioPersoGrand, setTrioPersogrand] = useState(pdrTrioPersoGrand.prix ?? 0)
        const mounted = useRef(false);
        useEffect(() => {
            mounted.current = true;
            return () => {
                mounted.current = false;
            };
        }, []);

        return (<><TextFieldUpdateOnChange label="Grand"
            InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>
            }}
            value={TrioPersoGrand}
            onChange={(e) => {
                pdrTrioPersoGrand.prix = parseFloat(e)
                if (mounted.current)
                    setTrioPersogrand(pdrTrioPersoGrand.prix)
                PointdeRetrait.update(pdr)
            }}
        /></>)
    }
    const BoissontrioChef = () => {
        const [TrioChefPetit, setTrioChefpetit] = useState(pdrTrioChefPetit.prix ?? 0)
        const [TrioChefGrand, setTrioChefgrand] = useState(pdrTrioChefGrand.prix ?? 0)
        const mounted = useRef(false);
        useEffect(() => {
            mounted.current = true;
            return () => {
                mounted.current = false;
            };
        }, []);
        return (<><TextFieldUpdateOnChange label="Petit"
            InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>
            }}
            value={TrioChefPetit}
            onChange={(e) => {
                pdrTrioChefPetit.prix = parseFloat(e)
                if (mounted.current)
                    setTrioChefpetit(pdrTrioChefPetit.prix)
                PointdeRetrait.update(pdr)
            }}
        />
            <TextFieldUpdateOnChange label="Grand"
                InputProps={{
                    endAdornment: <InputAdornment position="end">€</InputAdornment>
                }}
                value={TrioChefGrand}
                onChange={(e) => {
                    pdrTrioChefGrand.prix = parseFloat(e)
                    if (mounted.current)
                        setTrioChefgrand(pdrTrioChefGrand.prix)
                    PointdeRetrait.update(pdr)
                }}
            /></>)
    }
    const BoissonGarnitures = () => {
        const [PrixGarniture, setPrixGarniture] = useState(pdrGarniture.prix ?? 0)
        const mounted = useRef(false);
        useEffect(() => {
            mounted.current = true;
            return () => {
                mounted.current = false;
            };
        }, []);
        return (<><TextFieldUpdateOnChange key="pgarniture"
            label="Prix des Garnitures"
            InputProps={{
                endAdornment: <InputAdornment position="end">€</InputAdornment>
            }}
            value={PrixGarniture}
            disableAutoFocus={true}
            onChange={(e) => {
                pdr.ConfigMenu.Garnitures.forEach(gx => {
                    gx.prix = parseFloat(e)
                })
                if (mounted.current)
                    setPrixGarniture(e)
                PointdeRetrait.update(pdr)
            }}
        /></>)
    }

    return (<div className="TarifProduit">
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Simple<div></div></div>}>
            <BoissonSimple key={`trfpdr${pdr.id}_${new Date()}`} />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Duo<div></div></div>}>
            <BoissonDuo key={`trfpdr${pdr.id}_${new Date()}`} />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Trio personnalisé<div></div></div>}>
            <BoissonTrioPerso key={`trfpdr${pdr.id}_${new Date()}`} />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Trio du chef<div></div></div>}>
            <BoissontrioChef key={`trfpdr${pdr.id}_${new Date()}`} />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Garnitures<div></div></div>}>
            <BoissonGarnitures key={`trfpdr${pdr.id}_${new Date()}`} />
        </Collapsible>
    </div>)
}
const DispoProduit = ({ pdr }) => {
    var parfumdata = pdr.ConfigMenu.Boissons
        .map(x => {
            x.taille.map(y => y.boisson = x.name)
            return x.taille;

        })
        .flat()
        .map(x => {
            x.parfums.map(y => y.taille = x.name)
            x.parfums.map(y => y.boisson = x.boisson)
            return x.parfums;
        })
        .flat()
        .reduce((pv, curr) => {
            if (pv.length === 0)
                pv.push(curr)
            if (pv.filter(fx => fx.ref === curr.ref).length === 0)
                pv.push(curr)
            return pv
        }, [])

    var thedata = pdr.ConfigMenu.Boissons
        .map(x => {
            return x.taille;
        })
        .flat()
        .map(x => {
            x.The.map(y => y.taille = x.name)
            return x.The;
        })
        .flat()
        .reduce((pv, curr) => {
            if (pv.length === 0)
                pv.push(curr)
            if (pv.filter(fx => fx.ref === curr.ref).length === 0)
                pv.push(curr)
            return pv
        }, [])
    var tailledata = pdr.ConfigMenu.Boissons
        .map(x => {
            x.taille.map(y => y.boisson = x.name)
            return x.taille;

        })
        .flat()
        .reduce((pv, curr) => {
            if (pv.length === 0)
                pv.push(curr)
            if (pv.filter(fx => fx.ref === curr.ref).length === 0)
                pv.push(curr)
            return pv
        }, [])
    var sucredata = pdr.ConfigMenu.Sucre
    var glacondata = [pdr.ConfigMenu.SansGlacons, pdr.ConfigMenu.Glacons]
    var garnituresdata = pdr.ConfigMenu.Garnitures

    return (<div className="DispoProduit">
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Parfums {`(${parfumdata.filter(x=>x.disponible).length}/${parfumdata.length})`}<div></div></div>}>
            <DataTable
                key={`dtbl_${pdr.id}}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Boissons',
                        selector: row => row.boisson,
                        sortable: true,
                    },
                    {
                        name: 'Taille',
                        selector: row => row.taille,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                pdr.ConfigMenu.Boissons.forEach(bx => {
                                    bx.taille.forEach(tx => {
                                        let _parfum = tx.parfums.find(sx => sx.ref === row.ref)
                                        if (_parfum) {
                                            _parfum.disponible = checked
                                        }
                                    })
                                })
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={parfumdata}
            />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Taille {`(${tailledata.filter(x=>x.disponible).length}/${tailledata.length})`}<div></div></div>}>
            <DataTable
                key={`dtbl_${pdr.id}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Boissons',
                        selector: row => row.boisson,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                pdr.ConfigMenu.Boissons.forEach(bx => {
                                    let _taille = bx.taille.find(sx => sx.ref === row.ref)
                                    if (_taille) {
                                        _taille.disponible = checked
                                    }

                                })
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={tailledata}
            />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Thé {`(${thedata.filter(x=>x.disponible).length}/${thedata.length})`}<div></div></div>}>
            <DataTable
                key={`dtbl_${pdr.id}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Taille',
                        selector: row => row.taille,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                pdr.ConfigMenu.Boissons.forEach(bx => {
                                    bx.taille.forEach(tx => {
                                        let _tea = tx.The.find(sx => sx.ref === row.ref)
                                        if (_tea) {
                                            _tea.disponible = checked
                                        }
                                    })
                                })
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={thedata}
            />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Garnitures {`(${garnituresdata.filter(x=>x.disponible).length}/${garnituresdata.length})`}<div></div></div>}>
            <DataTable
                key={`3dtbl_${pdr.id}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Départements',
                        selector: row => row.option_list_name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                pdr.ConfigMenu.Garnitures.find(sx => sx.ref === row.ref).disponible = checked
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={garnituresdata}
            />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Sucre{`(${sucredata.filter(x=>x.disponible).length}/${sucredata.length})`}<div></div></div>}>
            <DataTable
                key={`4dtbl_${pdr.id}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Départements',
                        selector: row => row.option_list_name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                pdr.ConfigMenu.Sucre.find(sx => sx.ref === row.ref).disponible = checked
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={sucredata}
            />
        </Collapsible>
        <Collapsible trigger={<div className="mytrigger"><div className="picto"></div>Glaçons{`(${glacondata.filter(x=>x.disponible).length}/${glacondata.length})`}<div></div></div>}>
            <DataTable
                key={`5dtbl_${pdr.id}`}
                pagination
                columns={[
                    {
                        name: 'SKU',
                        selector: row => row.ref,
                        sortable: true,
                    },
                    {
                        name: 'Nom',
                        selector: row => row.name,
                        sortable: true,
                    },
                    {
                        name: 'Départements',
                        selector: row => row.option_list_name,
                        sortable: true,
                    },
                    {
                        name: 'Disponibilitée',
                        sortable: true,
                        selector: row => row.disponible ?? false,
                        cell: (row, idx) => <MySwitcher key={`mswt${idx}_${row.ref}`} trueLabel="Disponible" falseLabel="Indisponible"
                            value={row.disponible}
                            Onchecked={(checked) => {
                                if (pdr.ConfigMenu.Glacons.ref === row.ref)
                                    pdr.ConfigMenu.Glacons.disponible = checked
                                if (pdr.ConfigMenu.SansGlacons.ref === row.ref)
                                    pdr.ConfigMenu.SansGlacons.disponible = checked
                                PointdeRetrait.update(pdr)
                            }}
                        />,
                    },
                ]}
                data={glacondata}
            />
        </Collapsible>

    </div>)
}
const MySwitcher = ({ value = false, Onchecked, trueLabel, falseLabel }) => {
    const [checked, setcheck] = useState(value)

    return (<label className="switch">
        <input type="checkbox" onClick={() => {
            let ck = !checked
            setcheck(ck)
            Onchecked(ck)
        }
        } defaultChecked={checked}></input>
        <span className={"slider round " + (checked ? "open" : "closed")}>{checked ? trueLabel : falseLabel}</span>
    </label>)
}
const FraisdeServe = ({ pdr }) => {


    let pourcent = pdr.taxe?.pourcent ?? 0, sampleprice = 10;
    const [maxCommandeSimultane, setmaxCommandeSimultane] = useState(pdr.maxCommandeSimultane ?? 0)
    const [constante, setconstante] = useState(pdr.taxe?.constante ?? 0)
    const [pourcentDisplay, setpourcentDisplay] = useState(pourcent * 100 ?? 0)
    const getsample = () => pourcent * sampleprice + constante;
    const [sample, setsample] = useState(getsample())


    return (<div className="FraisdeServe">
        <div >
            <TextFieldUpdateOnChange label="commandes simultannées"
                value={maxCommandeSimultane}
                onChange={(e) => {
                    pdr.maxCommandeSimultane = parseInt(e)
                    setmaxCommandeSimultane(e)
                    PointdeRetrait.update(pdr)
                }
                }
            /></div>
        <div className="taxe">
            <TextFieldUpdateOnChange label="Frais de service"
                value={pourcentDisplay}
                onChange={(e) => {
                    let value = parseFloat(e)
                    setpourcentDisplay(value)
                    pourcent = value / 100
                    pdr.taxe.pourcent = pourcent
                    setsample(getsample())
                    PointdeRetrait.update(pdr)
                }
                }
                InputProps={{ endAdornment: "%" }}
                helperText="Pourcentage rajouté au prix totale"
            />
            <span className="plus">+</span>
            <TextFieldUpdateOnChange label="Frais de service"
                value={constante}
                onChange={(e) => {
                    let value = parseFloat(e)
                    setconstante(value)
                    pdr.taxe.constante = value
                    setsample(getsample())
                    PointdeRetrait.update(pdr)
                }
                }
                helperText="Constante rajouté au prix totale"
                InputProps={{ endAdornment: "€" }}
            />

            <div className="sample">
                Pour une comande de {sampleprice}€ les frais de service seront de {sample.toFixed(2)}€
            </div>
        </div>
    </div>)

}
class TextFieldUpdateOnChange extends React.Component {
    INTERVAL_WAIT = 1000;
    timer = null;


    constructor(props) {
        super(props)
        this.state = { value: this.props.value }
    }


    render() {
        let { name, InputProps, helperText, id, label } = this.props
        return (<>
            <TextField
                id={id}
                label={label}
                variant="outlined"
                name={name}
                placeholder="5"
                value={this.state.value}
                type="number"
                onChange={e => this.handlechange(e)}
                InputProps={InputProps}
                helperText={helperText}
            />
        </>)
    }

    handlechange(e) {
        var value = e.target.value
        this.setState({ value: value })
        if (this.timer)
            clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.props.onChange(value)
        }, this.INTERVAL_WAIT);
    }
}
